import { useMetaStore } from "@/application/stores/meta";
import { useRoute, useRouter } from "vue-router";
import { AppIdentifier } from "@/application/enums";
import { useApp } from "@/application/composables/app";
import { useOnboardingStore } from "@/application/stores/onboarding";

export const useCheckForOnboarding = () => {
  const metaStore = useMetaStore();
  const router = useRouter();
  const route = useRoute();
  const { appIdentifier } = useApp();
  const onboardingStore = useOnboardingStore();

  const action = () => {
    if (
      appIdentifier !== AppIdentifier.TenantAdmin ||
      !metaStore.meta ||
      (route.name && String(route.name).includes("onboarding.")) ||
      onboardingStore.hasOnboardingFlowStarted
    ) {
      return;
    }

    router.push({ name: "onboarding.welcome" });
  };

  return { action };
};
